var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"prescriber"}},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('pages.memorial.new.title')))]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('i',[_vm._v(_vm._s(_vm.$t('pages.memorial.new.text')))])]),_vm._v(" "),_c('b-container',[_c('ajax-new',{attrs:{"name":_vm.name,"uri":_vm.uri,"config":{ headers: { 'Content-Language': _vm.$translation.getLocale() } }}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba8fb15","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Memorial/new.vue
// module id = 872
// module chunks = 1